import { create } from 'zustand'

export type Panel = 'softphone' | 'dialer' | 'contacts' | 'reports'
export type NotificationType = 'info' | 'warn' | 'error'

export interface Notification {
  id: string
  message: string
  type: NotificationType
  createdAt: string
}

interface UiStoreState {
  activePanel: Panel
  notifications: Notification[]
  setActivePanel: (panel: Panel) => void
  addNotification: (message: string, type?: NotificationType) => string
  removeNotification: (id: string) => void
  clearNotifications: () => void
}

export const useUiStore = create<UiStoreState>()((set) => ({
  activePanel: 'softphone',
  notifications: [],
  setActivePanel: (activePanel) => set({ activePanel }),
  addNotification: (message, type = 'info') => {
    const id = crypto.randomUUID()
    const note: Notification = {
      id,
      message,
      type,
      createdAt: new Date().toISOString(),
    }
    set((state) => ({ notifications: [...state.notifications, note] }))
    return id
  },
  removeNotification: (id) =>
    set((state) => ({
      notifications: state.notifications.filter((n) => n.id !== id),
    })),
  clearNotifications: () => set({ notifications: [] }),
}))
